module.exports = "<div class=\"rw-marker-content\">\n  <table width=\"100%\">\n    <tr>\n      <td style=\"width: 30%\">\n        <div class=\"content-image\" imageBg [imageBgImage]=\"content.image\">\n\n        </div>\n      </td>\n      <td style=\"width: 70%\">\n        <div class=\"title\"> {{content.title}}</div>\n        <div class=\"detail\"> {{content.detail}}</div>\n\n      </td>\n    </tr>\n  </table>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/map/info-box-content.component.html
// module id = 1021
// module chunks = 3